"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ValueVertical = require("./ValueVertical");

var _ValueVertical2 = _interopRequireDefault(_ValueVertical);

var _ValueHorizontal = require("./ValueHorizontal");

var _ValueHorizontal2 = _interopRequireDefault(_ValueHorizontal);

var _ValueDefault = require("./ValueDefault");

var _ValueDefault2 = _interopRequireDefault(_ValueDefault);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Option',

  components: {
    ValueVertical: _ValueVertical2.default,
    ValueHorizontal: _ValueHorizontal2.default,
    ValueDefault: _ValueDefault2.default
  },

  props: ['state', 'option', 'group'],

  data: function data() {
    return {
      inputValue: "",
      valid: true
    };
  },


  watch: {
    inputValue: function inputValue(val) {
      this.$emit('changed', this.option.id, val, this.group);
    }
  },

  computed: {
    // Styling class based on style type
    valuesClasses: function valuesClasses() {
      return {
        'pcm-Option_Values-defaultRadio': this.option.styleType === 'default-radio',
        'pcm-Option_Values-verticalRadio': this.option.styleType === 'vertical-radio',
        'pcm-Option_Values-horizontalRadio': this.option.styleType === 'horizontal-radio'
      };
    },


    // Component based on style type
    valueComponentName: function valueComponentName() {
      if (this.option.styleType === 'default-radio') return "ValueDefault";
      if (this.option.styleType === 'horizontal-radio') return "ValueHorizontal";
      return "ValueVertical";
    }
  },

  methods: {
    // Event handler for value clicked
    valueChanged: function valueChanged(value) {
      // Bubble event to parent
      this.$emit('changed', this.option.id, value);
    },
    inputChanged: function inputChanged(event) {
      if (!event) return;

      var closestOptionGroup = event.target.closest('.pcm-Option');

      if (this.option.styleType === 'input') {
        if (this.option.min && this.inputValue < this.option.min || this.option.max && this.inputValue > this.option.max) {
          closestOptionGroup.setAttribute('aria-invalid', true);

          this.valid = false;
        } else {
          closestOptionGroup.setAttribute('aria-invalid', false);
          this.valid = true;
        }
      }
    }
  },

  mounted: function mounted() {
    if (this.option.styleType === "input") {
      this.inputValue = this.state["option_" + this.option.id];
    }

    this.inputChanged();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//